import moment from "moment";

// 将给定的日期字符串转换为指定的日期时间格式
export function formatStrToStr(date, fmtFrom, fmtTo = 'YYYY-MM-DD HH:mm:ss') {
  if (!date) {
    return moment().format(fmtTo);
  } else {
    return moment(date, fmtFrom).format(fmtTo);
  }
};

// 将给定的日期格式化为指定的日期时间格式，并返回格式化后的字符串
export function formatDate(date, fmt = 'YYYY-MM-DD HH:mm:ss') {
  if (!date) {
    return moment().format(fmt);
  } else {
    return moment(date).format(fmt);
  }
};

// 将给定的以秒为单位的时间戳格式化为指定的日期时间格式，并返回格式化后的字符串
export function formatSecond(seconds, fmt = 'YYYY-MM-DD HH:mm:ss') {
  return moment.unix(seconds).format(fmt);
};

// 获取指定日期（或当前日期）的 UNIX 时间戳（以秒为单位），
// 其中 UNIX 时间戳是指从 1970年1月1日 00:00:00 UTC 到指定日期时间的秒数
export function getSeconds(date) {
  if (!date) {
    return moment().unix();  
  } else {
    return moment(date).unix();
  }
};

// 获取指定日期（或当前日期）的 时间戳（以毫秒为单位），
// 时间戳是指从 1970年1月1日 00:00:00 UTC 到指定日期时间的毫秒数
export function getTs(date) {
  if (!date) {
    return moment().valueOf();
  } else {
    return moment(date).valueOf();
  }
};

// 将一个表示日期的字符串转换为 JavaScript 的 Date 对象
export function toDate(strDate) {
  if (strDate) {
    return new Date(strDate.replace(/\-/g,"/"));
  } else {
    return strDate;
  }
};

// 从给定的日期中减去指定的时间数量，并以指定的格式返回
export function subtract(date, diff, unit, fmt = 'YYYY-MM-DD HH:mm:ss') {
  if (!date) {
    return moment().subtract(diff, unit).format(fmt)
  } else {
    return moment(date).subtract(diff, unit).format(fmt)
  }
};

// 从给定的日期中加上指定的时间数量，并以指定的格式返回
export function add(date, diff, unit, fmt = 'YYYY-MM-DD HH:mm:ss') {
  if (!date) {
    return moment().add(diff, unit).format(fmt)
  } else {
    return moment(date).add(diff, unit).format(fmt)
  }
};

// 当前的本地时间，并以指定的格式返回
export function getNow(fmt = 'YYYY-MM-DD HH:mm:ss') {
  return moment().format(fmt);
};

// 获取当前的 UTC 时间，并以指定的格式返回
export function getNowUtc(fmt = 'YYYY-MM-DD HH:mm:ss') {
  return moment.utc().format(fmt);
};

// 将给定的 UTC 时间转换为本地时间，并以指定的格式返回
export function utcToLocal(date, fmt = 'YYYY-MM-DD HH:mm:ss') {
  return moment.utc(date).local().format(fmt);
};

// 将给定的本地时间转换为 UTC 时间，并以指定的格式返回
export function localToUtc(date, fmt = 'yyyy-MM-DD HH:mm:ss') {
  if (date) {
    return moment(date, fmt).utc().format(fmt)
  } else {
    return null
  }
};

// 将给定的 UTC 时间转换为本地时间，并返回对应的时间戳（以毫秒为单位）
export function utcToLocalTs(date) {
  return moment.utc(date).local().valueOf();
};

export function diffUtc(date, date2, unit) {
  return moment.utc(date).diff(moment.utc(date2), unit);
};

export function diff(date, date2, unit) {
  return moment(date).diff(moment(date2), unit);
};

export function showDuration(lastduration) {
  var hours = Math.trunc(lastduration / (60 * 60))
  var mins = Math.trunc((lastduration - hours * 60 * 60) / 60)
  var secs = lastduration - hours * 60 * 60 - mins * 60
  return (hours > 1 ? hours + ' hours ' : hours > 0 ? hours + ' hour ' : '')
                    + (mins > 0 ? mins + ' min ' : '')
                    + (secs > 0 ? secs + ' sec ' : '')

};

export function showBreDuration(lastduration) {
  var hours = Math.trunc(lastduration / (60 * 60))
  var mins = Math.trunc((lastduration - hours * 60 * 60) / 60)
  var secs = lastduration - hours * 60 * 60 - mins * 60
  return (hours > 1 ? hours + ' hs ' : hours > 0 ? hours + ' h ' : '')
                    + (mins > 0 ? mins + ' m ' : '')
                    + (secs > 0 ? secs + ' s ' : '')

};

export function getTimeZone(){
  var offset = 0 - new Date().getTimezoneOffset();
  // 计算小时和分钟部分
  var hours = Math.abs(Math.floor(offset / 60));
  hours = (hours < 10 ? '0' : '') + hours;
  var minutes = Math.abs(offset % 60);
  minutes = (minutes < 10 ? '0' : '') + minutes;
  
  // 确定时区方向
  var sign = (offset < 0) ? "-" : "+";
  
  // 格式化为 "+HH:mm" 的字符串格式
  var formattedTimeZone = sign + hours + ":" + minutes;
  return formattedTimeZone;
};

export function getLastWeek(){ 
  const currentDate = moment()
  let lastWeekStartDate = moment(currentDate).clone().subtract(1, 'weeks').startOf('isoWeek').toDate();
  let lastWeekEndDate = moment(currentDate).clone().subtract(1, 'weeks').endOf('isoWeek').toDate();
  return [lastWeekStartDate,lastWeekEndDate]
};

export function getThisMonth(){
  const currentDate = moment()
  let thisMonthStartDate = moment(currentDate).clone().startOf('month').toDate();
  let thisMonthEndDate = moment(currentDate).clone().endOf('day').toDate();
  return [thisMonthStartDate, thisMonthEndDate];
};

export function getRelativeTime(timestamp){
  let current = moment().valueOf()
  return moment(current).to(moment(timestamp)) 
}



// WEBPACK FOOTER //
// ./src/assets/js/time.js